module.exports = __webpack_public_path__ + "static/media/blendingwhite.f4e154c8.png";